import { render } from "./Company.vue?vue&type=template&id=5d9357d6&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=5d9357d6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9357d6"]])

export default __exports__